import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sync(event) {
    if (window.tinymce) {
      tinymce.triggerSave()
    }
  }
}
